module.exports = __webpack_public_path__ + "c6bebd2e1f1da8ffc7203f2316cfac5a.png";